import {organisationService, userService} from '../../services';
import { router } from '../../helpers';
import {store} from "../index";
import {i18n} from "../../i18n";

const getDefaultState = () => {
    return {
        status: { loggedIn: false },
        user: { dependants: [], tooltips_complete: false, welcome_shown: false, affiliate_welcome_shown: false, testscan_complete: false, members_invited: false, partners_invited: false },
        admin: false
    }
}

const state = getDefaultState()

const actions = {
    agreeTerms({ dispatch, commit }) {
        userService.agreeTerms()
            .then(
                user => {
                    if (user) {

                        if (user && user.roles && user.roles.includes('organisation')) {
                            commit('agreeTermsOrganisationSuccess');
                            if (this.state.account.user.email_verified_at) {
                                router.push('/dashboard');
                            }
                            else {
                                router.push('/verify');
                            }
                        }
                        else {
                            commit('agreeTermsSuccess');
                            if(!user.membership) {
                                router.push('/shop');
                            }
                            else if (this.state.lastRoute === 'activate') {
                                console.log(this.state.account.user.email_verified_at)
                                if (this.state.account.user.email_verified_at) {
                                    router.push('/shop');
                                }
                                else {
                                    router.push('/verify');
                                }
                            }
                            else if (this.state.lastRoute !== 'agree-terms') {
                                console.log("redirect to:" + this.state.lastRoute)
                                router.push({name: this.state.lastRoute});
                            }
                            else {
                                router.push('/shop');
                            }
                        }
                    }
                },
                error => {
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });

        userService.login(email, password)
            .then(
                user => {

                    if (user) {
                        commit('loginSuccess', user);
                        console.log(this.state.lastRoute)
                        console.log(user.terms_agreed)

                        i18n.locale = user.preferred_language

                        if (user && user.roles && user.roles.includes('organisation')) {
                            console.log(this.state.account.user.email_verified_at)
                            if (this.state.account.user.email_verified_at) {
                                router.push('/dashboard');
                            }
                            else {
                                router.push('/verify');
                            }
                        }
                        else {
                            if (this.state.lastRoute === 'activate') {
                                router.push('/activate');
                            }
                            else if(!user.membership) {
                                router.push('/shop');
                            }
                            else if (this.state.lastRoute === 'activate') {
                                console.log(this.state.account.user.email_verified_at)
                                if (this.state.account.user.email_verified_at) {
                                    if(!user.terms_agreed) {
                                        router.push('/agree-terms');
                                    }
                                    else {
                                        router.push('/shop');
                                    }
                                }
                                else {
                                    router.push('/verify');
                                }
                            }
                            else if (this.state.lastRoute === 'agree-terms') {
                                console.log('boo')
                                router.push('/agree-terms');
                            }
                            else {
                                if(!user.terms_agreed) {
                                    router.push('/agree-terms');
                                }
                                else {
                                    router.push('/shop');
                                }
                            }
                        }
                    }



                },
                error => {
                    console.log('login failed')
                    commit('loginFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    loginVerified({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });

        return userService.login(email, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    return user;
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    logout({ commit }) {
        commit('logout')
    },
    register({ dispatch, commit }, { name, email, email_confirmation, mobile, address1, address2, town, county, postcode, country, password, password_confirmation, organisations, makeTagsPublic, recaptchaToken, terms, brand }) {
        commit('registerRequest', { email });

        return userService.register(name, email, email_confirmation, mobile, address1, address2, town, county, postcode, country, password, password_confirmation, organisations, makeTagsPublic, recaptchaToken, terms, brand)
            .then(
                user => {
                    commit('registerSuccess', user);
                    //router.push('/verify');
                    return user;
                },
                error => {
                    commit('registerFailure');
                    console.log(error)
                    //dispatch('alert/error', error, { root: true });
                }
            );
    },
    registerOrganisation({ dispatch, commit }, { organisationName, organisationPhone, organisationCategory, affiliate_partner, postcode, address1, address2, town, county, country, name, email, email_confirmation, mobile, password, password_confirmation, recaptchaToken, latitude, longitude, terms, brand }) {
        //commit('registerRequest', { email });

        return organisationService.register(organisationName, organisationPhone, organisationCategory, affiliate_partner, postcode, address1, address2, town, county, country, name, email, email_confirmation, mobile, password, password_confirmation, recaptchaToken, latitude, longitude, terms, brand)
            .then(
                user => {
                    commit('registerSuccess', user);
                    router.push('/verify');
                    return user;
                },
                error => {
                    commit('registerFailure');
                    console.log(error)
                    //dispatch('alert/error', error, { root: true });
                }
            );
    },
    addDependant({ dispatch, commit }, { name, relationship, organisations, makeTagsPublic, school, brand }) {
        return userService.addDependant(name, relationship, organisations, makeTagsPublic, school, brand)
            .then(
                dependant => {
                    if (dependant.data) {
                        commit('addDependantSuccess', dependant.data);
                        dispatch('alert/success', 'Dependant added', { root: true });
                        return dependant.data
                    }
                },
                error => {
                    console.log(error)

                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    updateDependant({ dispatch, commit }, { localEditedItem }) {
        return userService.updateDependant(localEditedItem)
            .then(
                dependant => {
                    if (dependant.data) {
                        commit('updateDependantSuccess', dependant.data);
                        dispatch('alert/success', 'Dependant updated', { root: true });
                        return dependant.data
                    }
                },
                error => {
                    console.log(error)

                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    deleteDependant({ commit }, { localDeletedIndex }) {
        commit('deleteDependantSuccess', localDeletedIndex);
    },
    loadDependants({ commit }, dependants) {
        console.log(dependants)
        commit('loadDependants', dependants);
    },
    switchRole({ commit }) {
        commit('switchRole');
    },
    setSelf({ dispatch, commit }, user) {
        commit('setSelf', user);
    },
    updateSelf({ dispatch, commit }, { name, email, email1, email2, mobile, password, organisations, address1, address2, town, county, postcode, country, make_tags_public, preferred_language }) {
        return userService.updateSelf(name, email, email1, email2, mobile, password, organisations, address1, address2, town, county, postcode, country, make_tags_public, preferred_language)
            .then(
                user => {
                    commit('updateSuccess', user);
                    dispatch('alert/success', 'Account updated', { root: true });
                    return user;
                },
                error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    updateOrganisation({ dispatch, commit }, { id, name, phone, organisation_category_id, affiliate_partner, postcode, address1, address2, town, county, country, latitude, longitude, password, picture }) {
        return organisationService.update(id, name, phone, organisation_category_id, affiliate_partner, postcode, address1, address2, town, county, country, latitude, longitude, password, picture)
            .then(
                organisation => {
                    commit('updateOrganisationSuccess', organisation);
                    dispatch('alert/success', 'Organisation updated', { root: true });
                    return organisation;
                },
                error => {
                    console.log(error)
                    if (error.response && error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    updateVerificationSent({ dispatch, commit }, sentAt) {
        commit('updateVerificationSent', sentAt);
    },
    updateVerifiedAt({ dispatch, commit }, verifiedAt) {
        commit('updateVerifiedAt', verifiedAt);
    },
    updateMembership({ dispatch, commit }, subscribed) {
        commit('updateMembership', subscribed);
    },
    updateSubscription({ dispatch, commit }, subscription) {
        commit('updateSubscription', subscription);
    },
    updateSMSCount({ dispatch, commit }, count) {
        commit('updateSMSCount', count);
    },
    updateBundleClaimedAt({ dispatch, commit }, bundleClaimedAt) {
        commit('updateBundleClaimedAt', bundleClaimedAt);
    },
    updateDefaultPaymentMethod({ dispatch, commit }, defaultPaymentMethod) {
        commit('updateDefaultPaymentMethod', defaultPaymentMethod);
    },
    instantActivate({ dispatch, commit }, { codeString, name, email, email_confirmation, mobile, password, password_confirmation, recaptchaToken, terms, brand }) {
        commit('registerRequest', { email });

        return userService.instantActivate(codeString, name, email, email_confirmation, mobile, password, password_confirmation, recaptchaToken, terms, brand)
            .then(
                user => {
                    commit('registerSuccess', user);

                    return user;
                },
                error => {
                    commit('registerFailure');
                    console.log(error)
                    //dispatch('alert/error', error, { root: true });
                }
            );
    },
    completeTooltips({ commit }) {

        return userService.completeTooltips()
            .then(
                user => {
                    commit('completeTooltips');
                    return user;
                },
                error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    completeWelcome({ commit }) {
        return userService.completeWelcome()
            .then(
                user => {
                    commit('completeWelcome');
                    return user;
                },
                error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    completeAffiliateWelcome({ commit }) {
        return userService.completeAffiliateWelcome()
            .then(
                user => {
                    commit('completeAffiliateWelcome');
                    return user;
                },
                error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    completeTestscan({ commit }) {
        return userService.completeTestscan()
            .then(
                user => {
                    commit('completeTestscan');
                    return user;
                },
                error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    completeInviteMembers({ commit }) {
        return userService.completeInviteMembers()
            .then(
                user => {
                    commit('completeInviteMembers');
                    return user;
                },
                error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
    completeInvitePartners({ commit }) {
        return userService.completeInvitePartners()
            .then(
                user => {
                    commit('completeInvitePartners');
                    return user;
                },
                error => {
                    console.log(error)
                    if (error.response && [401, 403, 419].includes(error.response.status)) {
                        userService.logout().then(() => {
                            store.dispatch('alert/error', i18n.t('You have been logged out due to inactivity'), { root: true });
                        })
                    }
                }
            );
    },
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        console.log(user.dependants)
        state.user = user;
        console.log(state.user.dependants)
    },
    loginFailure(state) {
        state.status = {};
        state.user = getDefaultState();
    },
    logout(state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, getDefaultState())
    },
    agreeTermsSuccess(state) {
        state.user.terms_agreed = true;
    },
    agreeTermsOrganisationSuccess(state) {
        state.user.admin_for_organisations[0].terms_agreed = true;
    },
    registerRequest(state, user) {
        //state.status = { loggingIn: true };
        state.user = user;
    },
    registerFailure(state) {
        state.status = {};
        state.user = getDefaultState();
    },
    registerSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    addDependantSuccess(state, dependant) {
        // if (state.user.dependants == null)  {
        //     state.user.dependants = [];
        // }
        state.user.dependants.push(dependant)
    },
    updateDependantSuccess(state, dependant) {
        //state.user.dependants.push(dependant)
        const item = state.user.dependants.find(item => item.id === dependant.id);
        Object.assign(item, dependant);
    },
    deleteDependantSuccess(state, localDeletedIndex) {
        state.user.dependants.splice(localDeletedIndex, 1)
    },
    loadDependants(state, dependants) {
        console.log(dependants)
        state.user.dependants = dependants.data
    },
    switchRole(state) {
        if (state.admin === true) {
            state.admin = false
        }
        else {
            state.admin = true
        }
    },
    setSelf (state, user) {
        state.user = user
    },
    updateSuccess(state, user) {
        state.user.name = user.name;
        state.user.email = user.email;
        state.user.mobile = user.mobile;
        state.user.organisations = user.organisations;
        state.user.make_tags_public = user.make_tags_public;
    },
    updateOrganisationSuccess(state, organisation) {
        state.user.admin_for_organisations[0] = organisation;
    },
    updateVerificationSent(state, sentAt) {
        state.user.email_verification_sent_at = sentAt
    },
    updateVerifiedAt(state, verifiedAt) {
        state.user.email_verified_at = verifiedAt
    },
    updateMembership(state, subscribed) {
        state.user.membership = subscribed
    },
    updateSubscription(state, subscription) {
        state.user.stripe_subscription = subscription
    },
    updateSMSCount(state, count) {
        state.user.sms_count = count
    },
    updateBundleClaimedAt(state, claimedAt) {
        state.user.bundle_claimed_at = claimedAt
    },
    updateDefaultPaymentMethod(state, defaultPaymentMethod) {
        state.user.default_payment_method = defaultPaymentMethod
    },
    completeTooltips(state) {
        return state.user.tooltips_complete = true
    },
    completeWelcome(state) {
        return state.user.welcome_shown = true
    },
    completeAffiliateWelcome(state) {
        return state.user.affiliate_welcome_shown = true
    },
    completeTestscan(state) {
        return state.user.testscan_complete = true
    },
    completeInviteMembers(state) {
        return state.user.members_invited = true
    },
    completeInvitePartners(state) {
        return state.user.partners_invited = true
    },
};

const getters = {
    dependants: state => {
        return state.user.dependants
    },
    personalise: state => {
        // spread operator forces clone rather than by reference which would cause changes to original property
        let list = [...state.user.dependants];
        list.unshift({name: state.user.name, id: 0})
        return list
    },
    name: state => {
        return state.user.name
    },
    user: state => {
        return state.user
    },
    isAdmin: state => {
        if (state.user && state.user.roles && state.user.roles.includes('organisation')) {
            return true
        }
        return false
    },
    organisationName: state => {
        if (state.user && state.user.roles && state.user.roles.includes('organisation')) {
            return state.user.admin_for_organisations[0].name
        }
    },
    loggedIn: state => {
        return state.status.loggedIn
    },
    hasMembership: state => {
        return state.user.membership
    },
    hasActiveTrial: state => {
        return state.user.on_trial
    }
}

export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
